/**
 * Represents an error that occurs when handling an HTTP response.
 * @template TResponse The type of the HTTP response.
 */
export class HttpResponseError extends Error {
    response;
    static Name = 'HttpResponseError';
    /**
     * @param message - The error message.
     * @param response - The HTTP response associated with the error.
     * @param options - Additional error options.
     */
    constructor(message, response, options) {
        super(message, options);
        this.response = response;
    }
}
export default HttpResponseError;
//# sourceMappingURL=HttpResponseError.js.map